import React from 'react';
import NavBar from '../components/NavBar';
import './BookingsPage.css';
import API from '../API';
import { Link } from 'react-router-dom';
import BookingDetailsPanel from '../components/BookingDetailsPanel';



export default class BookingsPage extends React.Component {

    constructor(props) {
        super(props);

        this.fetchOrders();

        this.state = {orders: []}
    }

    

    fetchOrders() {
        API.fetchClient("orders").then((orders) => {
            console.log(orders);
            this.setState({orders});
        })
    }

    render() {
        return <div style={{paddingTop:0,display:"flex",flex:1}}>
            <NavBar />
            
            <div className='bookingsRoot'>
            <p style={{fontSize:30, fontWeight:"600"}}>Siparişlerim</p>

            <div className='bookingsParent'>
                <p>Sipariş listesi ({this.state.orders.length})</p>
                <div className='bookingOrders'>
                {this.state.orders.map((x,i) =>
                    <BookingDetailsPanel order={x} key={i} details={true} />)}

                </div>
            </div>
            </div>
            
            
        </div>
    }
}


//TABLE
{/* <div style={{paddingTop:0,display:"flex",flex:1}}>
            <NavBar />
            
            <div className='bookingsRoot'>
            <p style={{fontSize:30, fontWeight:"600"}}>Siparişlerim</p>

            <div className='bookingsParent'>
                <p>Sipariş listesi (1)</p>

                <table>
                    <tr className='bookingHeaders'>
                        <th></th>
                        <th style={{width:"fit-content"}}>Sipariş Numarası</th>
                        <th>Oluşturma Tarihi</th>
                        <th className='where'>Nereden</th>
                        <th className='where'>Nereye</th>
                        <th>Sürücü</th>
                        <th>Fiyat</th>
                        <th>Durum</th>
                    </tr>

                    

                    {this.state.orders.map((x,i) => <tr className='tdOrder' key={i}>
                        <img style={{width:"5vw"}} src={require('../assets/vehicles/Motor.png')} />
                        <td className='tdID'>#{x._id.substring(18).toUpperCase()}</td>
                        <td><p>{new Date(parseInt(x._id.substring(0,8),16)*1000).toLocaleString("islamic")}</p></td>
                        <td className='tdAddress'>
                            {getDescription(x.from) != "" && <p>{getDescription(x.from)}</p>}
                            <p>{x.from.Label}</p>
                            
                        </td>
                        <td className='tdAddress'><p>{x.to.Label}</p></td>
                        <td>{x.driverDetails != undefined && x.driverDetails.name}</td>
                        <td>{x.pricing.price.toFixed(2)}₺</td>
                        <td><div style={{backgroundColor:"green", padding:5,paddingLeft:10,paddingRight:10,width:"fit-content", borderRadius:10, color:"white"}}>Sürücü aranıyor</div></td>
                    </tr>)}
                </table>
            </div>
            </div>
            
            
        </div> */}

        

const getDescription = (address) => {
    var p = "";

    if(address.building && address.building != "") p += "Bina: " + address.building + " ";
    if(address.floor && address.floor != "") p += "Kat: " + address.floor + " ";
    if(address.door && address.door != "") p += "Daire: " + address.door + " ";

    return p;
}